import { render, staticRenderFns } from "./LocalSwitcher.vue?vue&type=template&id=60d0c7ef&scoped=true&"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LocalSwitcher.vue?vue&type=style&index=0&id=60d0c7ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0c7ef",
  null
  
)

export default component.exports